import { combineReducers } from 'redux';

import { reducers } from '@/rootState';

const createRootReducer = () => {
	return combineReducers(reducers);
};

export default createRootReducer;
